/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */

import dynamic from 'next/dynamic'
import classNames from 'classnames'
import {
  AllStrapiV4WidgetTypes,
  TStrapiV4AMCWidget,
  TStrapiV4AMCWidgetV1,
  TStrapiV4ListingWidget,
} from '../common-types'
import { getColorHexFromDotBrandColorNotation } from '../utils/colors'
import { StrapiV4BreadcrumbWidget } from './breadcrumb-widget/breadcrumb-widget'
import { StrapiV4SectionFAQs } from './faqs-section/faqs-section'
import { StrapiV4PrivacyWidget } from './privacy/privacy'
import { StrapiV4RichTextEditor } from './rich-text-editor/rich-text-editor'
import { StrapiV4YoutubeWidget } from './youtube-widget/youtube-widget'
import { StrapiV4SectionCardTypeOneWidget } from './section-card-type-one/section-card-type-one'
import { StrapiV4TitleSubTitleIconCards } from './title-subtitle-icon-cards/title-subtitle-icon-cards' //
import { StrapiV4TrustWidget } from './trust/trust'
import { StrapiV4GreenStickyCTA } from './green-sticky-cta/green-sticky-cta'
import { StrapiV4TestimonialWidget } from './testimonials-widget/testimonial-widget'
import { StrapiV4BenefitsWidget } from './benefits-widget/benefits-widget'
import StrapiV4GuidesWidget from './guides-widget/guides-widget'
// import INDLearnWidgetV1 from './ind-learn-v1/INDLearnWidgetV1'
import { ICompare } from '@/components/MutualFunds/amc/types'
import colors from '@ind-money/tailwind/tokens/colors'

const StrapiV4MultimediaV0 = dynamic(
  () => import('./multimedia-v0/multimedia-v0'),
)

const StrapiV4FeatureCardsSection = dynamic(
  () => import('./feature-cards-section/feature-cards-section'),
)

const StrapiV4SectionCardTypeTwoWidget = dynamic(
  () => import('./section-card-type-two/section-card-type-two'),
)
const StrapiV4ListingV0Widget = dynamic(() => import('./listing-v0/listing-v0'))

const StrapiDataWrapper = dynamic(
  () => import('../common-components/data-wrapper/data-wrapper'),
)

const StrapiV4SectionCardTypeThreeWidget = dynamic(
  () => import('./section-card-type-three/section-card-type-three'),
)

const StrapiV4AMCV2Widget = dynamic(
  () => import('./amc-widget-v2/amc-widget-v2'),
)

const StrapiV4AMCV1Widget = dynamic(
  () => import('./amc-widget-v1/amc-widget-v1'),
)

const StrapiV4AMCV0Widget = dynamic(
  () => import('./amc-widget-v0/amc-widget-v0'),
)
const CompareAMC = dynamic(
  () => import('@/components/MutualFunds/amc/compare-other-amc'),
)

const StrapiV4SectionCardTypeFourWidget = dynamic(
  () => import('./section-card-type-four/section-card-type-four'),
)

const StrapiV4KeyInformationV0Widget = dynamic(
  () => import('./key-information-v0/key-information-v0'),
)

const StrapiV4HeroWidgetV0 = dynamic(
  () => import('./hero-widget-v0/hero-widget-v0'),
)

const StrapiV4WidgetSelector = (
  props: AllStrapiV4WidgetTypes & {
    notHero?: boolean
    addScrollId?: boolean
    placeholders?: object
    addClassNames?: string | null
    host?: string
  },
) => {
  if (props.__component === 'widgets.hero-section-comon-widget') {
    return <StrapiV4HeroWidgetV0 {...props} />
  }
  if (props.__component === 'widgets.benefits-widget') {
    return <StrapiV4BenefitsWidget {...props} />
  }
  if (props.__component === 'widgets.testimonials-widget') {
    return <StrapiV4TestimonialWidget {...props} />
  }
  if (props.__component === 'widgets.youtube-widget') {
    return <StrapiV4YoutubeWidget {...props} />
  }
  if (props.__component === 'widgets.section-card-type-one') {
    return <StrapiV4SectionCardTypeOneWidget data={props} />
  }
  if (props.__component === 'widgets.guides-widget') {
    return <StrapiV4GuidesWidget {...props} notHero={props.notHero} />
  }
  if (props.__component === 'widgets.breadcrumb-widget') {
    return <StrapiV4BreadcrumbWidget {...props} notHero={props.notHero} />
  }
  if (props.__component === 'widgets.feature-cards-section') {
    return <StrapiV4FeatureCardsSection {...props} />
  }
  if (props.__component === 'widgets.faqs-section') {
    return (
      <div
        className={classNames('mx-auto py-8 xl:py-12', {
          'herolike-wrapper ': !props.notHero,
          'px-4 md:px-0': props.notHero,
        })}
      >
        <StrapiV4SectionFAQs
          {...props}
          addScrollId={props.addScrollId}
          json_placeholder={props.placeholders}
        />
      </div>
    )
  }
  if (props.__component === 'widgets.rich-text-editor') {
    const { bg_color } = props
    const bgColor = bg_color?.color
      ? getColorHexFromDotBrandColorNotation(bg_color.color)
      : colors.brand.white
    return (
      <div
        style={{
          backgroundColor: bgColor,
        }}
      >
        <div
          className={classNames({
            'herolike-wrapper': !props.notHero,
            'py-8 xl:py-12': !props.addClassNames,
            [props.addClassNames ?? '']: props.addClassNames,
          })}
        >
          <StrapiV4RichTextEditor content={props.rich_text_html} />
        </div>
      </div>
    )
  }

  if (props.__component === 'widgets.three-col-t-subt-icon-cards') {
    return (
      <StrapiV4TitleSubTitleIconCards
        cards={props.three_col_cards}
        {...props}
      />
    )
  }

  if (props.__component === 'widgets.section-card-type-two') {
    const { bg_color } = props

    const hexColor = bg_color?.color
      ? getColorHexFromDotBrandColorNotation(bg_color.color)
      : null

    const bgColor = hexColor ?? bg_color?.custom_color ?? colors.brand.white

    return (
      <div
        style={{
          backgroundColor: bgColor,
        }}
      >
        <div className="herolike-wrapper py-8 xl:py-12">
          <StrapiV4SectionCardTypeTwoWidget {...props} />
        </div>
      </div>
    )
  }
  if (props.__component === 'widgets.static-widgets') {
    if (props.static_widget_name === 'privacy') {
      return (
        <div className="bg-brand-black">
          <div className="herolike-wrapper py-9 xl:py-25">
            <StrapiV4PrivacyWidget host={props.host} />
          </div>
        </div>
      )
    }
    if (props.static_widget_name === 'trust') {
      return (
        <div className="bg-brand-white">
          <div className="herolike-wrapper py-9 xl:py-25">
            <StrapiV4TrustWidget />
          </div>
        </div>
      )
    }
    if (props.static_widget_name === 'ind-learn') {
      return null
    }

    return null
  }

  if (props.__component === 'widgets.section-card-type-three') {
    return (
      <StrapiV4SectionCardTypeThreeWidget img={props.img} title={props.title} />
    )
  }

  if (props.__component === 'widgets.key-information-v0') {
    return (
      <StrapiV4KeyInformationV0Widget data={props} notHero={props.notHero} />
    )
  }

  if (props.__component === 'widgets.section-card-type-four') {
    return (
      <StrapiV4SectionCardTypeFourWidget data={props} notHero={props.notHero} />
    )
  }

  if (props.__component === 'widgets.green-sticky-cta') {
    return <StrapiV4GreenStickyCTA {...props} />
  }

  if (props.__component === 'widgets.multimedia-v0') {
    return <StrapiV4MultimediaV0 data={props} />
  }
  if (props.__component === 'widgets.data-wrapper') {
    return (
      <div
        className={classNames('p-4', {
          'herolike-wrapper ': !props.notHero,
        })}
      >
        <StrapiDataWrapper script={props.script} />
      </div>
    )
  }

  if (props.__component === 'widgets.dynamic-place-holder-v0') {
    switch (props.widget_type) {
      case 'ListingV0': {
        const data = props.data_source?.api as TStrapiV4ListingWidget['data']
        return (
          <StrapiV4ListingV0Widget
            data={data}
            apiDataPath={props.data_source?.api_data_path ?? null}
            notHero={props.notHero}
          />
        )
      }
      case 'AMCWidgetV0': {
        const data = props.data_source?.api as TStrapiV4AMCWidget
        return <StrapiV4AMCV0Widget data={data} />
      }

      case 'AMCWidgetV1': {
        const data = props.data_source?.api as TStrapiV4AMCWidgetV1
        return <StrapiV4AMCV1Widget data={data} />
      }

      case 'AMCWidgetV2': {
        const data = props.data_source?.api as TStrapiV4AMCWidget
        return <StrapiV4AMCV2Widget data={data} />
      }

      case 'MFAmcCompareV0': {
        const data = props.data_source?.api as ICompare
        return (
          <div
            className={classNames({
              'herolike-wrapper': !props.notHero,
            })}
          >
            <CompareAMC compare={data} />
          </div>
        )
      }
      default:
        return null
    }
  }

  return null
}

export default StrapiV4WidgetSelector
